import { FETCH_PERSON_AFFILIATIONS } from 'stores/redux/actions/types';
import reducer from '../common/reducer';

const addReducer = reducer(FETCH_PERSON_AFFILIATIONS);
export default addReducer;
